export function getRestoredHistoryValue(key: string, value: unknown) {
  if (key === "initialYear") {
    return Number(value);
  }

  return value;
}
